module.exports = __webpack_public_path__ + "img/bus-img.86cc3c5f.svg";